import React from 'react';
import { useLocation } from 'react-router-dom';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import TreeNode, {
	TreeData,
	TreeItemData,
	TreeItemInterface,
} from '../../layouts/SidePanel/TreeNode';

interface Props {
	cancellationData: CancellationData;
}

const ReinstatementSidebar = (props: Props) => {
	const { cancellationData } = props;

	const { policy, selectedCancellation } = cancellationData;

	const { reinstatement } = selectedCancellation;

	if (!policy || !selectedCancellation) {
		return <LargeCenterSpinner />;
	}

	const { pathname } = useLocation();

	const routeName = pathname.split('/').pop();
	const cancellationLink = `/policy/${policy.locator}/cancellations/${selectedCancellation.locator}`;
	const reinstatementLink = `${cancellationLink}/reinstatements/${reinstatement.locator}`;
	const detailsLink = `${reinstatementLink}/details`;

	const getRootItem = () => {
		const children = ['Details'];

		return {
			id: 'root',
			children,
			hasChildren: true,
			isExpanded: true,
			isChildrenLoading: false,
			data: {
				title: 'root',
			},
		} as TreeItemInterface;
	};

	const getItems = () => {
		const isDetailsSelected =
			routeName === 'details' || routeName === 'auxData';

		const items: TreeItemData = {
			root: getRootItem(),
			Details: {
				id: 'Details',
				children: [],
				hasChildren: false,
				isExpanded: true,
				isChildrenLoading: false,
				data: {
					title: 'Details',
					link: detailsLink,
					selected: isDetailsSelected,
				},
			},
		};

		return items;
	};

	const initializeTree = () => {
		const sidePanelData: TreeData = {
			rootId: 'root',
			items: getItems(),
		};

		return sidePanelData;
	};

	const tree = initializeTree();

	return <TreeNode defaultExpanded={[]} treeData={tree} />;
};

export default withCancellationContext<Props>(ReinstatementSidebar);
